import { Instagram, Facebook } from "lucide-react";

const Footer = () => (
  <footer
    data-testid="footer-section"
    className="relative border-t border-white/10 pt-20 pb-10 px-6 md:px-10 overflow-hidden"
  >
    <div className="max-w-[1600px] mx-auto">
      <div className="flex flex-col md:flex-row md:items-end justify-between gap-10">
        <div>
          <img
            src="/breethe-logo.webp"
            alt="Breethe"
            className="brand-logo w-full max-w-2xl opacity-90 select-none"
          />
          <p className="mt-6 max-w-sm text-white/50 font-light text-base">
            Performance nasal strips for people who refuse to breathe small.
          </p>
        </div>

        <div className="flex flex-col gap-6 md:items-end">
          <div className="flex gap-4">
            <a
              href="https://www.instagram.com/breetheau"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-social-instagram"
              aria-label="Breethe on Instagram"
              className="w-12 h-12 border border-white/15 flex items-center justify-center text-white/60 transition-[color,border-color,transform] duration-300 hover:text-volt hover:border-volt active:scale-95"
            >
              <Instagram size={18} />
            </a>
            <a
              href="https://www.facebook.com/profile.php?id=61594671693087"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-social-facebook"
              aria-label="Breethe on Facebook"
              className="w-12 h-12 border border-white/15 flex items-center justify-center text-white/60 transition-[color,border-color,transform] duration-300 hover:text-volt hover:border-volt active:scale-95"
            >
              <Facebook size={18} />
            </a>
          </div>
          <a
            href="mailto:info@breethe.com.au"
            data-testid="footer-contact-link"
            className="font-plex text-xs uppercase tracking-[0.25em] text-white/60 hover:text-volt transition-colors duration-300"
          >
            info@breethe.com.au
          </a>
        </div>
      </div>

      <div data-testid="footer-follow-us" className="mt-16 flex flex-col sm:flex-row sm:items-center gap-3 sm:gap-6">
        <p className="font-plex text-[10px] uppercase tracking-[0.3em] text-white/40">Follow us</p>
        <div className="flex gap-6 font-plex text-xs uppercase tracking-[0.2em]">
          <a
            href="https://www.instagram.com/breetheau"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer-follow-instagram"
            className="flex items-center gap-2 text-white/60 hover:text-volt transition-colors duration-300"
          >
            <Instagram size={14} />
            Instagram
          </a>
          <a
            href="https://www.facebook.com/profile.php?id=61594671693087"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer-follow-facebook"
            className="flex items-center gap-2 text-white/60 hover:text-volt transition-colors duration-300"
          >
            <Facebook size={14} />
            Facebook
          </a>
        </div>
      </div>

      <div data-testid="footer-sitemap" className="mt-10 pt-10 border-t border-white/10 grid grid-cols-2 md:grid-cols-4 gap-8">
        <div>
          <p className="font-plex text-[10px] uppercase tracking-[0.3em] text-white/40 mb-4">Explore</p>
          <ul className="space-y-3 font-plex text-xs uppercase tracking-[0.2em]">
            <li><a href="/#manifesto" data-testid="footer-link-why" className="text-white/60 hover:text-volt transition-colors duration-300">Why Breethe</a></li>
            <li><a href="/#product" data-testid="footer-link-strip" className="text-white/60 hover:text-volt transition-colors duration-300">The Strip</a></li>
            <li><a href="/#pricing" data-testid="footer-link-pricing" className="text-white/60 hover:text-volt transition-colors duration-300">Pricing</a></li>
            <li><a href="/#stories" data-testid="footer-link-stories" className="text-white/60 hover:text-volt transition-colors duration-300">Stories</a></li>
          </ul>
        </div>
        <div>
          <p className="font-plex text-[10px] uppercase tracking-[0.3em] text-white/40 mb-4">Support</p>
          <ul className="space-y-3 font-plex text-xs uppercase tracking-[0.2em]">
            <li><a href="/contact" data-testid="footer-link-contact" className="text-white/60 hover:text-volt transition-colors duration-300">Contact us</a></li>
            <li><a href="/shipping-policy" data-testid="footer-link-shipping" className="text-white/60 hover:text-volt transition-colors duration-300">Shipping policy</a></li>
            <li><a href="/refund-policy" data-testid="footer-link-refunds" className="text-white/60 hover:text-volt transition-colors duration-300">Refund policy</a></li>
            <li><a href="/manage" data-testid="footer-link-manage-sub" className="text-white/60 hover:text-volt transition-colors duration-300">Manage subscription</a></li>
          </ul>
        </div>
        <div>
          <p className="font-plex text-[10px] uppercase tracking-[0.3em] text-white/40 mb-4">Legal</p>
          <ul className="space-y-3 font-plex text-xs uppercase tracking-[0.2em]">
            <li><a href="/terms" data-testid="footer-link-terms" className="text-white/60 hover:text-volt transition-colors duration-300">Terms of service</a></li>
            <li><a href="/privacy" data-testid="footer-link-privacy" className="text-white/60 hover:text-volt transition-colors duration-300">Privacy policy</a></li>
          </ul>
        </div>
        <div>
          <p className="font-plex text-[10px] uppercase tracking-[0.3em] text-white/40 mb-4">Founders</p>
          <ul className="space-y-3 font-plex text-xs uppercase tracking-[0.2em]">
            <li><a href="/#founders" data-testid="footer-link-founders" className="text-white/60 hover:text-volt transition-colors duration-300">Join the list</a></li>
            <li><a href="/ambassadors" data-testid="footer-link-ambassadors" className="text-white/60 hover:text-volt transition-colors duration-300">Ambassadors</a></li>
            <li><a href="/#pricing" data-testid="footer-link-trial" className="text-white/60 hover:text-volt transition-colors duration-300">$14.95 trial</a></li>
          </ul>
        </div>
      </div>

      <div className="mt-16 pt-6 border-t border-white/10 flex flex-col md:flex-row justify-between gap-3 font-plex text-[10px] uppercase tracking-[0.25em] text-white/30">
        <span>© 2026 Breethe Labs — All rights reserved</span>
        <a href="/manage" data-testid="footer-manage-link" className="hover:text-volt transition-colors duration-300">
          Manage subscription
        </a>
        <span>Breathe responsibly</span>
      </div>
    </div>
  </footer>
);

export default Footer;
